export type NodeStatus = 'pending' | 'in_progress' | 'completed' | 'error';

export interface PipelineNodeData {
  step: number;
  name: string;
  status: NodeStatus;
  message?: string;
  progress?: number;
  duration?: number;
  startTime?: number;
  details?: StepDetails;
}

export interface StepDetails {
  // Step 1: Select Images
  s3Uri?: string;
  imageCount?: number;
  cloudWatchUrl?: string;

  // Step 2: Download
  downloadPath?: string;
  downloadedCount?: number;

  // Step 3: Model Config
  modelName?: string;
  classesNumber?: number;

  // Step 4: Bulk Predict
  processedCount?: number;
  sampleResponses?: string[];

  // Step 5: Add Annotations
  batchId?: string;
  annotationCount?: number;
  insightsCount?: number;

  // Step 6: Weed Extraction
  highWeedCount?: number;
  instancesExtracted?: number;
  weedExtractsUri?: string;
}

// UpdateType from gRPC protobuf
export enum UpdateType {
  UNKNOWN = 0,
  STEP_STARTED = 1,
  STEP_PROGRESS = 2,
  STEP_COMPLETED = 3,
  PIPELINE_COMPLETED = 4,
  PIPELINE_ERROR = 5,
}

// Helper functions
export const mapUpdateTypeToStatus = (updateType: number): NodeStatus => {
  switch (updateType) {
    case UpdateType.STEP_STARTED:
      return 'in_progress';
    case UpdateType.STEP_PROGRESS:
      return 'in_progress';
    case UpdateType.STEP_COMPLETED:
      return 'completed';
    case UpdateType.PIPELINE_ERROR:
      return 'error';
    default:
      return 'pending';
  }
};

export const getStepMessage = (update: any): string => {
  // Extract message from appropriate field based on step
  if (update.selectImagesMessage) return update.selectImagesMessage;
  if (update.bulkPredictMessage) return update.bulkPredictMessage;
  if (update.addAnnotationsMessage) return update.addAnnotationsMessage;
  if (update.weedInstancesMessage) return update.weedInstancesMessage;
  if (update.downloadMessage) return update.downloadMessage;
  if (update.modelConfigMessage) return update.modelConfigMessage;
  return 'Processing...';
};

export const statusColors = {
  pending: '#9E9E9E',      // Gray
  in_progress: '#FF9800',  // Orange
  completed: '#4CAF50',    // Green
  error: '#F44336',        // Red
};

export const getStatusColor = (status: NodeStatus): string => {
  return statusColors[status];
};

export const getStatusIcon = (status: NodeStatus): string => {
  switch (status) {
    case 'pending':
      return '⚫';
    case 'in_progress':
      return '🟡';
    case 'completed':
      return '✅';
    case 'error':
      return '❌';
    default:
      return '⚫';
  }
};
